var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevasthanamDefaultBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 553,
    viewBox: "0 0 1366 553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-mask",
    d: "M0-24H1366V529H0Z",
    transform: "translate(0 361)",
    fill: "#fb8b24",
    opacity: 0.946
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.34,
    y1: 0.253,
    x2: 0.714,
    y2: 0.684,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb8b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.42,
    y1: 0.277,
    x2: 0.706,
    y2: 0.614,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.552,
    y1: 0.275,
    x2: 0.753,
    y2: 0.564,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.456,
    y1: 0.247,
    x2: 0.267,
    y2: 0.571,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.598,
    y1: 0.251,
    x2: 0.296,
    y2: 0.613,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.647,
    y1: 0.275,
    x2: 0.354,
    y2: 0.597,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.943,
    y1: 0.174,
    x2: 0.437,
    y2: 0.635,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.932,
    y1: 0.247,
    x2: 0.493,
    y2: 0.652,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.959,
    y1: 0.55,
    x2: 0.51,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.476,
    y1: 0.33,
    x2: 0.969,
    y2: 0.788,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb8b24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.41,
    y1: 0.335,
    x2: 0.92,
    y2: 0.805,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.322,
    y1: 0.365,
    x2: 0.598,
    y2: 0.667,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.332,
    y1: 0.43,
    x2: 0.526,
    y2: 0.662,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.25,
    y1: 0.362,
    x2: 0.391,
    y2: 0.662,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.797,
    y1: 0.376,
    x2: 0.612,
    y2: 0.66,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.731,
    y1: 0.341,
    x2: 0.479,
    y2: 0.66,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.743,
    y1: 0.286,
    x2: 0.409,
    y2: 0.665,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.671,
    y1: 0.261,
    x2: 0.183,
    y2: 0.705,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.622,
    y1: 0.25,
    x2: 0.06,
    y2: 0.757,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.597,
    y1: 0.5,
    x2: 0.107,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.612,
    y1: 0.732,
    x2: 0.085,
    y2: 0.307,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.654,
    y1: 0.716,
    x2: 0.172,
    y2: 0.295,
    xlinkHref: "#linear-gradient-10"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "devasthanam-default-banner",
    transform: "translate(0 -337)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bg-mask-2",
    "data-name": "bg-mask",
    d: "M0-24H1366V529H0Z",
    transform: "translate(0 361)",
    fill: "#fb8b24",
    opacity: 0.946
  })), /*#__PURE__*/React.createElement("g", {
    id: "large-banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_35",
    "data-name": "Mask Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7432",
    "data-name": "Group 7432",
    transform: "translate(0 245.111)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160318",
    "data-name": "Path 160318",
    d: "M714.766,433.527,28.4,48.5H153.194Q467.533,248.608,714.766,433.527Z",
    transform: "translate(-28.4 -48.5)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160319",
    "data-name": "Path 160319",
    d: "M507.579,433.527Q309.792,230.942,70.8,48.5H195.594Q363.359,216.908,507.579,433.527Z",
    transform: "translate(178.788 -48.5)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160320",
    "data-name": "Path 160320",
    d: "M300.391,433.527Q212.976,207.662,113.2,48.5H237.994C259.774,151.526,280.965,279.978,300.391,433.527Z",
    transform: "translate(385.975 -48.5)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160321",
    "data-name": "Path 160321",
    d: "M145,433.527c19.425-153.549,40.617-282,62.4-385.027H332.191Q232.414,207.5,145,433.527Z",
    transform: "translate(541.366 -48.5)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160322",
    "data-name": "Path 160322",
    d: "M145,433.527Q288.925,217.073,456.984,48.5H581.778Q342.492,230.777,145,433.527Z",
    transform: "translate(541.366 -48.5)",
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160323",
    "data-name": "Path 160323",
    d: "M145,433.527Q392.233,248.773,706.572,48.5H831.366Z",
    transform: "translate(541.366 -48.5)",
    fill: "url(#linear-gradient-6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160324",
    "data-name": "Path 160324",
    d: "M145,384.722Q474.349,246.033,831.366,69.7v70Q506.431,273.936,145,384.722Z",
    transform: "translate(541.366 0.305)",
    fill: "url(#linear-gradient-7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160325",
    "data-name": "Path 160325",
    d: "M145,287.112Q530.86,206.375,831.366,112.1v70Q547.931,238.076,145,287.112Z",
    transform: "translate(541.366 97.915)",
    fill: "url(#linear-gradient-8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160326",
    "data-name": "Path 160326",
    d: "M145,189.5q410.583-16.345,686.366-35v70.005Q555.878,206.178,145,189.5Z",
    transform: "translate(541.366 195.525)",
    fill: "url(#linear-gradient-9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160327",
    "data-name": "Path 160327",
    d: "M145,165.1q402.637,49.037,686.366,105.007v70.005Q531.154,246,145,165.1Z",
    transform: "translate(541.366 219.927)",
    fill: "url(#linear-gradient-10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160328",
    "data-name": "Path 160328",
    d: "M145,165.1Q506.136,276.051,831.366,410.117v70Q474.644,303.789,145,165.1Z",
    transform: "translate(541.366 219.927)",
    fill: "url(#linear-gradient-11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160329",
    "data-name": "Path 160329",
    d: "M145,165.1,831.366,550.127H706.572Q392.233,350.019,145,165.1Z",
    transform: "translate(541.366 219.927)",
    fill: "url(#linear-gradient-12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160330",
    "data-name": "Path 160330",
    d: "M145,165.1Q342.786,367.685,581.778,550.127H456.984Q289.219,381.719,145,165.1Z",
    transform: "translate(541.366 219.927)",
    fill: "url(#linear-gradient-13)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160331",
    "data-name": "Path 160331",
    d: "M145,165.1q87.414,225.865,187.191,385.027H207.4C185.617,447.1,164.425,318.648,145,165.1Z",
    transform: "translate(541.366 219.927)",
    fill: "url(#linear-gradient-14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160332",
    "data-name": "Path 160332",
    d: "M300.391,165.1c-19.426,153.548-40.617,282-62.4,385.027H113.2Q212.977,391.13,300.391,165.1Z",
    transform: "translate(385.975 219.927)",
    fill: "url(#linear-gradient-15)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160333",
    "data-name": "Path 160333",
    d: "M507.579,165.1Q363.653,381.554,195.594,550.127H70.8Q310.086,367.85,507.579,165.1Z",
    transform: "translate(178.788 219.927)",
    fill: "url(#linear-gradient-16)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160334",
    "data-name": "Path 160334",
    d: "M714.766,165.1Q467.533,349.853,153.194,550.127H28.4Z",
    transform: "translate(-28.4 219.927)",
    fill: "url(#linear-gradient-17)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160335",
    "data-name": "Path 160335",
    d: "M714.766,165.1Q385.416,303.789,28.4,480.122v-70Q353.335,275.886,714.766,165.1Z",
    transform: "translate(-28.4 219.927)",
    fill: "url(#linear-gradient-18)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160336",
    "data-name": "Path 160336",
    d: "M714.766,165.1Q328.906,245.837,28.4,340.112V270.107Q311.835,214.136,714.766,165.1Z",
    transform: "translate(-28.4 219.927)",
    fill: "url(#linear-gradient-19)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160337",
    "data-name": "Path 160337",
    d: "M714.766,189.5q-410.584,16.345-686.366,35V154.5Q303.888,172.827,714.766,189.5Z",
    transform: "translate(-28.4 195.525)",
    fill: "url(#linear-gradient-20)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160338",
    "data-name": "Path 160338",
    d: "M714.766,287.112Q312.129,238.076,28.4,182.1v-70Q328.612,206.21,714.766,287.112Z",
    transform: "translate(-28.4 97.915)",
    fill: "url(#linear-gradient-21)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160339",
    "data-name": "Path 160339",
    d: "M714.766,384.722Q353.629,273.771,28.4,139.7v-70Q385.122,246.033,714.766,384.722Z",
    transform: "translate(-28.4 0.305)",
    fill: "url(#linear-gradient-22)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(573.231 566.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157983",
    "data-name": "Path 157983",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(69.741 7.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503",
    transform: "translate(88.414 17.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6501",
    "data-name": "Group 6501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500",
    transform: "translate(20.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157958",
    "data-name": "Path 157958",
    d: "M83.3,8.7v9.935l12.522-1.895-3.79-2.125,6.146-1.895Z",
    transform: "translate(-82.455 -6.472)",
    fill: "#ee2a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157959",
    "data-name": "Path 157959",
    d: "M80.487,0h.691a.486.486,0,0,1,.487.487V17.771H80V.487A.471.471,0,0,1,80.487,0Z",
    transform: "translate(-80)",
    fill: "#752f28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499",
    transform: "translate(3.508 5.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157960",
    "data-name": "Path 157960",
    d: "M96.184,24.921h0a.313.313,0,0,0,.077.23.308.308,0,0,0,.128.128.291.291,0,0,0,.2.077.671.671,0,0,0,.384-.051,1.05,1.05,0,0,0,.41-.41.482.482,0,0,0,.051-.2v-.179a.9.9,0,0,0-.077-.358c-.026-.026-.026-.051-.051-.1a.354.354,0,0,0-.1-.077c-.051,0-.128-.026-.179-.026a.364.364,0,0,0-.154.051l-.154.154-.154.23a2.213,2.213,0,0,1-.179.256c-.026.026-.051.051-.077.051a.188.188,0,0,1-.154.051h-.384c.026.051.051.128.077.179a.748.748,0,0,1,.051.23.551.551,0,0,1,0,.2.818.818,0,0,1-.077.358,1.038,1.038,0,0,1-.128.23.8.8,0,0,1-.282.23.413.413,0,0,1-.23.077,1.038,1.038,0,0,1-.282,0,.958.958,0,0,1-.461-.128,1.508,1.508,0,0,1-.717-1.1.872.872,0,0,1-.026-.256V24.46l.026-.026a.025.025,0,0,1,.026.026c.026.051.026.077.051.128l.077.23a1.819,1.819,0,0,0,.2.461.376.376,0,0,0,.128.154.558.558,0,0,0,.2.128.682.682,0,0,0,.307.077,1.037,1.037,0,0,0,.282,0,.516.516,0,0,0,.282-.077.5.5,0,0,0,.256-.307.508.508,0,0,0-.026-.282.369.369,0,0,0-.282-.23c-.077,0-.154-.026-.2,0h-.154l-.154-.23a2.255,2.255,0,0,1-.128-.384h.026a.564.564,0,0,1,.2.026,1.691,1.691,0,0,0,.359-.026.363.363,0,0,0,.23-.2c0-.026.026-.026.026-.051v-.077a.377.377,0,0,0-.128-.154.364.364,0,0,0-.154-.051.709.709,0,0,0-.23.026,2.871,2.871,0,0,0-.333.128c-.077.026-.128.077-.2.1h-.026c-.1-.154-.179-.307-.282-.487a.353.353,0,0,1,.1-.077.952.952,0,0,1,.487-.23A.921.921,0,0,1,94.955,23h.307a.435.435,0,0,1,.256.154.78.78,0,0,1,.2.41.631.631,0,0,1-.026.307,1,1,0,0,1-.2.358.256.256,0,0,1-.128.1c-.026.026-.051.026-.077.051h.026a1.247,1.247,0,0,0,.179.077.231.231,0,0,0,.128.026.291.291,0,0,0,.2-.077.679.679,0,0,0,.128-.154c.051-.077.077-.154.128-.23a1.057,1.057,0,0,1,.179-.282.69.69,0,0,1,.2-.179c.077-.026.128-.051.2-.077a.524.524,0,0,1,.282,0,.46.46,0,0,1,.23.1.957.957,0,0,1,.333.384,2.251,2.251,0,0,1,.128.384,2.781,2.781,0,0,1,.026.461,1.74,1.74,0,0,1-.077.487,1.379,1.379,0,0,1-.179.333.566.566,0,0,1-.333.256.748.748,0,0,1-.23.051,1.05,1.05,0,0,1-.282-.026.456.456,0,0,1-.282-.2.865.865,0,0,1-.154-.307,1.5,1.5,0,0,1-.051-.333.436.436,0,0,1,.026-.179c.051.051.051.051.077.026Z",
    transform: "translate(-93.7 -22.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157961",
    "data-name": "Path 157961",
    d: "M100.351,21.126h0a.8.8,0,0,0,.2.282,1.42,1.42,0,0,0,.2.154c.051.026.077.026.128.051a.532.532,0,0,0,.282.026.908.908,0,0,0,.282-.077,2.138,2.138,0,0,0,.307-.2.354.354,0,0,0,.1-.077c.026-.026.026-.026.051,0,.051.051.077.1.128.154s.077.1.128.154a.089.089,0,0,0,.026.051v.026l-.051.051a.778.778,0,0,1-.179.128.947.947,0,0,1-.282.128.325.325,0,0,1-.154.026.709.709,0,0,1-.23.026A1.575,1.575,0,0,1,100.94,22a.959.959,0,0,1-.307-.179,1,1,0,0,1-.2-.256l-.077-.154a.6.6,0,0,1-.051-.2v-.1c.026.051.026.026.051.026Z",
    transform: "translate(-98.61 -20.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157962",
    "data-name": "Path 157962",
    d: "M102.359,20c.128.128.282.256.41.384h0l-.179.179-.154.154c-.026,0-.026.026-.051.026h-.026c-.077-.051-.128-.1-.2-.154a.678.678,0,0,1-.128-.154L102,20.41v-.026c.1-.1.179-.2.282-.307.026-.026.051-.026.077-.077Z",
    transform: "translate(-99.875 -20)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_157963",
    "data-name": "Path 157963",
    d: "M2.585,174.2H41.507a1.486,1.486,0,0,1,1.485,1.485v4.174H1.1v-4.174A1.486,1.486,0,0,1,2.585,174.2Z",
    transform: "translate(-1.1 -129.593)",
    fill: "#f8991d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157964",
    "data-name": "Path 157964",
    d: "M14.885,152.1H47.508a1.486,1.486,0,0,1,1.485,1.485v4.174H13.4v-4.174A1.486,1.486,0,0,1,14.885,152.1Z",
    transform: "translate(-10.25 -113.152)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157965",
    "data-name": "Path 157965",
    d: "M22.285,130H51.144a1.486,1.486,0,0,1,1.485,1.485v4.174H20.8v-4.174A1.486,1.486,0,0,1,22.285,130Z",
    transform: "translate(-15.755 -96.711)",
    fill: "#f8991d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157966",
    "data-name": "Path 157966",
    d: "M32.085,107.8h23.84a1.486,1.486,0,0,1,1.485,1.485v4.174H30.6v-4.174A1.486,1.486,0,0,1,32.085,107.8Z",
    transform: "translate(-23.046 -80.196)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157967",
    "data-name": "Path 157967",
    d: "M44.385,85.8H61.926a1.486,1.486,0,0,1,1.485,1.485v4.174H42.9V87.285A1.47,1.47,0,0,1,44.385,85.8Z",
    transform: "translate(-32.196 -63.829)",
    fill: "#f8991d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157968",
    "data-name": "Path 157968",
    d: "M56.685,63.7H67.927a1.486,1.486,0,0,1,1.485,1.485v4.174H55.2V65.183A1.454,1.454,0,0,1,56.685,63.7Z",
    transform: "translate(-41.347 -47.386)",
    fill: "#f26522"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6502",
    "data-name": "Group 6502",
    transform: "translate(0.026 53.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157969",
    "data-name": "Path 157969",
    d: "M1.4,210.806a.723.723,0,0,1-.2-.589v-2.049a.8.8,0,0,1,.2-.563.819.819,0,0,1,.589-.2h.691a2.517,2.517,0,0,1,1.024.2,1.717,1.717,0,0,1,.666.615,2.169,2.169,0,0,1,0,1.946,1.407,1.407,0,0,1-.666.615,2.517,2.517,0,0,1-1.024.2H1.994A.715.715,0,0,1,1.4,210.806Zm1.229-.333a1.277,1.277,0,0,0,.947-.307,1.318,1.318,0,0,0,.307-.947,1.431,1.431,0,0,0-.307-.973,1.318,1.318,0,0,0-.947-.307H2.1a.155.155,0,0,0-.154.077.216.216,0,0,0-.051.179v2.049a.3.3,0,0,0,.051.179.221.221,0,0,0,.154.077h.538Z",
    transform: "translate(-1.2 -207.323)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157970",
    "data-name": "Path 157970",
    d: "M16.8,210.806a.723.723,0,0,1-.2-.589v-2.049a.8.8,0,0,1,.2-.563.819.819,0,0,1,.589-.2h1.613a.313.313,0,0,1,.23.077.252.252,0,0,1,.077.2.291.291,0,0,1-.077.2.313.313,0,0,1-.23.077H17.522a.155.155,0,0,0-.154.077.216.216,0,0,0-.051.179v.717h1.306a.313.313,0,0,1,.23.077.252.252,0,0,1,.077.2.291.291,0,0,1-.077.2.313.313,0,0,1-.23.077H17.317v.794a.3.3,0,0,0,.051.179.222.222,0,0,0,.154.077h1.588a.313.313,0,0,1,.23.077.252.252,0,0,1,.077.2.291.291,0,0,1-.077.2.313.313,0,0,1-.23.077h-1.69A2.286,2.286,0,0,1,16.8,210.806Z",
    transform: "translate(-12.657 -207.323)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157971",
    "data-name": "Path 157971",
    d: "M30.052,210.657a2.027,2.027,0,0,1-.41-.819l-.717-2.279a.231.231,0,0,1-.026-.128q0-.23.307-.23a.758.758,0,0,1,.256.051.4.4,0,0,1,.128.2l.717,2.33c.077.2.128.358.179.461s.1.128.179.128.1-.051.179-.128c.051-.1.1-.256.179-.461l.717-2.33a.4.4,0,0,1,.128-.2c.051-.051.128-.051.256-.051q.307,0,.307.23a.231.231,0,0,1-.026.128l-.717,2.279a2.189,2.189,0,0,1-.41.819.833.833,0,0,1-.589.256A.889.889,0,0,1,30.052,210.657Z",
    transform: "translate(-21.807 -207.174)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157972",
    "data-name": "Path 157972",
    d: "M43.7,210.911a.325.325,0,0,1-.1-.23v-1.793a1.466,1.466,0,0,1,1.613-1.588,1.893,1.893,0,0,1,.871.179,1.2,1.2,0,0,1,.563.563,1.792,1.792,0,0,1,.2.845v1.793a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.432.432,0,0,1-.256-.077.325.325,0,0,1-.1-.23v-.845H44.266v.845a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077A.291.291,0,0,1,43.7,210.911Zm2.458-1.613v-.461a1.1,1.1,0,0,0-.23-.768.855.855,0,0,0-.691-.256c-.615,0-.922.333-.922,1.024v.461Z",
    transform: "translate(-32.743 -207.249)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157973",
    "data-name": "Path 157973",
    d: "M59.045,210.659a1.975,1.975,0,0,1-.768-.487.283.283,0,0,1,.2-.461.477.477,0,0,1,.256.128,1.565,1.565,0,0,0,.563.333,2.2,2.2,0,0,0,.691.128,1.041,1.041,0,0,0,.538-.128.347.347,0,0,0,.179-.333.441.441,0,0,0-.2-.359,1.857,1.857,0,0,0-.691-.256,2.446,2.446,0,0,1-1.127-.461.9.9,0,0,1-.358-.717.676.676,0,0,1,.179-.487,1.189,1.189,0,0,1,.512-.333,2.414,2.414,0,0,1,.768-.128,2.162,2.162,0,0,1,.845.154,1.237,1.237,0,0,1,.563.435.34.34,0,0,1,.077.179.354.354,0,0,1-.128.23.364.364,0,0,1-.154.051.315.315,0,0,1-.256-.128.974.974,0,0,0-.41-.282,1.337,1.337,0,0,0-.538-.1,1.1,1.1,0,0,0-.563.1.361.361,0,0,0-.2.307.436.436,0,0,0,.2.333,2.635,2.635,0,0,0,.691.23,4.349,4.349,0,0,1,.871.282,1.087,1.087,0,0,1,.487.384.947.947,0,0,1,.154.538.738.738,0,0,1-.179.512,1.1,1.1,0,0,1-.487.333,2.14,2.14,0,0,1-.743.128A1.775,1.775,0,0,1,59.045,210.659Z",
    transform: "translate(-43.604 -207.1)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157974",
    "data-name": "Path 157974",
    d: "M73.183,210.911a.324.324,0,0,1-.1-.23v-2.817h-.973a.313.313,0,0,1-.23-.077.252.252,0,0,1-.077-.2.291.291,0,0,1,.077-.2.313.313,0,0,1,.23-.077H74.77a.313.313,0,0,1,.23.077.252.252,0,0,1,.077.2.291.291,0,0,1-.077.2.313.313,0,0,1-.23.077h-1v2.817a.25.25,0,0,1-.1.23.433.433,0,0,1-.256.077A.313.313,0,0,1,73.183,210.911Z",
    transform: "translate(-53.722 -207.249)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157975",
    "data-name": "Path 157975",
    d: "M86.4,210.836a.325.325,0,0,1-.1-.23v-3.1a.25.25,0,0,1,.1-.23.382.382,0,0,1,.256-.077.433.433,0,0,1,.256.077.325.325,0,0,1,.1.23v1.229h1.844v-1.229a.25.25,0,0,1,.1-.23.382.382,0,0,1,.256-.077.433.433,0,0,1,.256.077.325.325,0,0,1,.1.23v3.1a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.433.433,0,0,1-.256-.077.325.325,0,0,1-.1-.23v-1.332H86.991v1.332a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077A.313.313,0,0,1,86.4,210.836Z",
    transform: "translate(-64.509 -207.174)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157976",
    "data-name": "Path 157976",
    d: "M101.1,210.911a.324.324,0,0,1-.1-.23v-1.793a1.466,1.466,0,0,1,1.613-1.588,1.893,1.893,0,0,1,.871.179,1.2,1.2,0,0,1,.563.563,1.792,1.792,0,0,1,.2.845v1.793a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.432.432,0,0,1-.256-.077.325.325,0,0,1-.1-.23v-.845h-1.869v.845a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077A.291.291,0,0,1,101.1,210.911Zm2.458-1.613v-.461a1.1,1.1,0,0,0-.23-.768.855.855,0,0,0-.691-.256c-.615,0-.922.333-.922,1.024v.461Z",
    transform: "translate(-75.445 -207.249)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157977",
    "data-name": "Path 157977",
    d: "M115.8,210.836a.325.325,0,0,1-.1-.23V208.66a1.387,1.387,0,0,1,.435-1.075,1.717,1.717,0,0,1,1.178-.384,1.673,1.673,0,0,1,1.178.384,1.387,1.387,0,0,1,.435,1.075v1.946a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.433.433,0,0,1-.256-.077.25.25,0,0,1-.1-.23V208.66a.915.915,0,0,0-.23-.666,1.152,1.152,0,0,0-1.383,0,.915.915,0,0,0-.23.666v1.946a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077A.291.291,0,0,1,115.8,210.836Z",
    transform: "translate(-86.38 -207.174)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157978",
    "data-name": "Path 157978",
    d: "M130.4,210.911a.324.324,0,0,1-.1-.23v-1.793a1.466,1.466,0,0,1,1.613-1.588,1.893,1.893,0,0,1,.871.179,1.2,1.2,0,0,1,.563.563,1.792,1.792,0,0,1,.2.845v1.793a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.432.432,0,0,1-.256-.077.324.324,0,0,1-.1-.23v-.845h-1.844v.845a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077A.413.413,0,0,1,130.4,210.911Zm2.458-1.613v-.461a1.1,1.1,0,0,0-.23-.768.855.855,0,0,0-.691-.256c-.615,0-.922.333-.922,1.024v.461Z",
    transform: "translate(-97.242 -207.249)",
    fill: "#de3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157979",
    "data-name": "Path 157979",
    d: "M145.2,210.836a.325.325,0,0,1-.1-.23V208.48a1.16,1.16,0,0,1,1.28-1.28.947.947,0,0,1,.538.154,1.325,1.325,0,0,1,.435.41,1.325,1.325,0,0,1,.435-.41,1.074,1.074,0,0,1,.563-.128,1.16,1.16,0,0,1,1.28,1.28v2.125a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.433.433,0,0,1-.256-.077.324.324,0,0,1-.1-.23v-2.125a.824.824,0,0,0-.154-.563.656.656,0,0,0-.487-.179.548.548,0,0,0-.461.179.84.84,0,0,0-.154.538v2.125a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077.433.433,0,0,1-.256-.077.325.325,0,0,1-.1-.23V208.48a.84.84,0,0,0-.154-.538.563.563,0,0,0-.461-.2.57.57,0,0,0-.487.179.87.87,0,0,0-.154.563v2.125a.25.25,0,0,1-.1.23.382.382,0,0,1-.256.077C145.356,210.913,145.254,210.887,145.2,210.836Z",
    transform: "translate(-108.252 -207.174)",
    fill: "#de3826"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_160304",
    "data-name": "Path 160304",
    transform: "translate(71.023 9.023)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.656,0A38.656,38.656,0,1,1,0,38.656,38.656,38.656,0,0,1,38.656,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.6556510925293 0.9999923706054688 C 33.57172775268555 0.9999923706054688 28.64041900634766 1.995460510253906 23.99868392944336 3.958747863769531 C 19.51479721069336 5.85528564453125 15.48764038085938 8.570526123046875 12.02908325195312 12.02908325195312 C 8.570526123046875 15.48764038085938 5.85528564453125 19.51479721069336 3.958747863769531 23.99868392944336 C 1.995460510253906 28.64041900634766 0.9999923706054688 33.57172775268555 0.9999923706054688 38.6556510925293 C 0.9999923706054688 43.73957443237305 1.995460510253906 48.67089462280273 3.958747863769531 53.31262969970703 C 5.85528564453125 57.79651641845703 8.570526123046875 61.82366180419922 12.02908325195312 65.28221893310547 C 15.48764038085938 68.74076080322266 19.51479721069336 71.45601654052734 23.99868392944336 73.3525390625 C 28.64041900634766 75.31582641601562 33.57172775268555 76.31129455566406 38.6556510925293 76.31129455566406 C 43.73957443237305 76.31129455566406 48.67089462280273 75.31582641601562 53.31262969970703 73.3525390625 C 57.79651641845703 71.45601654052734 61.82366180419922 68.74076080322266 65.28221893310547 65.28221893310547 C 68.74076080322266 61.82366180419922 71.45601654052734 57.79651641845703 73.3525390625 53.31262969970703 C 75.31582641601562 48.67089462280273 76.31129455566406 43.73957443237305 76.31129455566406 38.6556510925293 C 76.31129455566406 33.57172775268555 75.31582641601562 28.64041900634766 73.3525390625 23.99868392944336 C 71.45601654052734 19.51479721069336 68.74076080322266 15.48764038085938 65.28221893310547 12.02908325195312 C 61.82366180419922 8.570526123046875 57.79651641845703 5.85528564453125 53.31262969970703 3.958747863769531 C 48.67089462280273 1.995460510253906 43.73957443237305 0.9999923706054688 38.6556510925293 0.9999923706054688 M 38.6556510925293 -7.62939453125e-06 C 60.00458526611328 -7.62939453125e-06 77.31129455566406 17.30672836303711 77.31129455566406 38.6556510925293 C 77.31129455566406 60.00458526611328 60.00458526611328 77.31129455566406 38.6556510925293 77.31129455566406 C 17.30672836303711 77.31129455566406 -7.62939453125e-06 60.00458526611328 -7.62939453125e-06 38.6556510925293 C -7.62939453125e-06 17.30672836303711 17.30672836303711 -7.62939453125e-06 38.6556510925293 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#f26522"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevasthanamDefaultBanner);
export default __webpack_public_path__ + "static/media/devasthanam-default-banner.aaefc271ef6fb3fe5bfb4341a5dc7518.svg";
export { ForwardRef as ReactComponent };